var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremisesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-455.513 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.513 186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.127,31.5a2.372,2.372,0,1,0-2.372,2.372A2.375,2.375,0,0,0,17.127,31.5Zm-2.372,1.476A1.476,1.476,0,1,1,16.232,31.5,1.478,1.478,0,0,1,14.755,32.977Z",
    transform: "translate(-10.626 -20.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.749,20.191v-.9a5.9,5.9,0,0,0-2.935.782l.446.777A5,5,0,0,1,13.749,20.191Z",
    transform: "translate(-9.62 -14.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.324,15.358v-.9a7.63,7.63,0,0,0-3.731.973l.439.781A6.733,6.733,0,0,1,12.324,15.358Z",
    transform: "translate(-8.195 -11.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,52.53a4.133,4.133,0,0,0-4.129,4.128c0,2.745,3.6,8.388,3.752,8.627l.376.587.377-.586c.153-.238,3.752-5.855,3.752-8.628A4.129,4.129,0,0,0,36.4,52.53Zm0,11.663c-.925-1.527-3.234-5.537-3.234-7.535a3.233,3.233,0,0,1,6.466,0C39.629,58.676,37.322,62.671,36.4,64.193Z",
    transform: "translate(-23.385 -35.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.54,57.432A2.372,2.372,0,1,0,41.912,59.8,2.375,2.375,0,0,0,39.54,57.432Zm0,3.848A1.476,1.476,0,1,1,41.017,59.8,1.478,1.478,0,0,1,39.54,61.28Z",
    transform: "translate(-26.53 -39.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.169,49.308a5.435,5.435,0,0,0-2.381-.543v.9a4.542,4.542,0,0,1,1.991.454Z",
    transform: "translate(-30.778 -33.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,45.643a6.9,6.9,0,0,0-3.211-.793v.9a6,6,0,0,1,2.793.689Z",
    transform: "translate(-30.778 -30.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.148,15.708a2.372,2.372,0,1,0-2.373-2.372A2.375,2.375,0,0,0,48.148,15.708Zm0-3.849a1.476,1.476,0,1,1-1.477,1.476A1.478,1.478,0,0,1,48.148,11.86Z",
    transform: "translate(-32.053 -9.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.608,46.872a2.372,2.372,0,1,0-2.373,2.372A2.375,2.375,0,0,0,74.608,46.872Zm-2.373,1.476a1.476,1.476,0,1,1,1.477-1.476A1.478,1.478,0,0,1,72.235,48.349Z",
    transform: "translate(-47.51 -30.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.131,8.1a4.117,4.117,0,0,0-7.058-.085A14.989,14.989,0,0,0,12.3,12.631a4.194,4.194,0,0,0-.686-.061A4.134,4.134,0,0,0,7.481,16.7a10.808,10.808,0,0,0,1.167,3.917,15.106,15.106,0,0,0-.128,1.925A14.907,14.907,0,1,0,27.131,8.1Zm9.8,10.69H34.522a4.117,4.117,0,0,0-4.638.005v-.006H26.791a.668.668,0,0,1,0-1.337h5.023a1.564,1.564,0,0,0,0-3.128h-1.65a.668.668,0,0,1,0-1.337H33.7A13.964,13.964,0,0,1,36.932,18.792Zm-4.725.183a3.236,3.236,0,0,1,3.233,3.233c0,2.017-2.307,6.013-3.232,7.534-.925-1.527-3.233-5.537-3.233-7.534A3.237,3.237,0,0,1,32.207,18.975ZM23.576,6.958a3.236,3.236,0,0,1,3.233,3.233c0,2.017-2.306,6.013-3.232,7.535-.925-1.527-3.234-5.538-3.234-7.535A3.236,3.236,0,0,1,23.576,6.958Zm-3.968,2.1a4.112,4.112,0,0,0-.161,1.129,6.659,6.659,0,0,0,.39,1.97H17.3a1.762,1.762,0,1,0,0,3.524h1.035a.866.866,0,1,1,0,1.732h-2.66a4.384,4.384,0,0,0,.068-.717,4.125,4.125,0,0,0-2.486-3.787A14.112,14.112,0,0,1,19.608,9.061Zm-8,4.405A3.236,3.236,0,0,1,14.843,16.7c0,2.017-2.307,6.013-3.232,7.535C10.686,22.708,8.377,18.7,8.377,16.7A3.237,3.237,0,0,1,11.611,13.467ZM10.377,27.629h3.511a.956.956,0,1,1,0,1.911H11.3A13.919,13.919,0,0,1,10.377,27.629Zm19.864,7.15H26.054a.679.679,0,1,1,0-1.357h6.189A14.041,14.041,0,0,1,30.241,34.779Zm3-2.253H26.054a1.575,1.575,0,1,0,0,3.149h2.254A14,14,0,0,1,11.86,30.437h2.028a1.851,1.851,0,1,0,0-3.7h-3.83a13.963,13.963,0,0,1-.641-4.192c0-.114.009-.228.012-.342.876,1.671,1.732,3.013,1.8,3.127l.376.587.377-.586a34.04,34.04,0,0,0,3.475-7.015h2.869a1.762,1.762,0,1,0,0-3.524H17.3a.866.866,0,0,1,0-1.732h2.867A39.9,39.9,0,0,0,23.2,18.819l.376.587.377-.586c.153-.238,3.752-5.855,3.752-8.628a4.121,4.121,0,0,0-.137-1.036A13.951,13.951,0,0,1,32.784,12.1H30.165a1.564,1.564,0,0,0,0,3.128h1.65a.668.668,0,0,1,0,1.337H26.791a1.564,1.564,0,0,0,0,3.128h2.154a4.1,4.1,0,0,0-.866,2.52c0,2.745,3.6,8.388,3.751,8.627l.376.587.378-.586c.153-.238,3.752-5.855,3.752-8.627a4.1,4.1,0,0,0-.866-2.52h1.678a14.165,14.165,0,0,1,.291,2.854A13.971,13.971,0,0,1,33.245,32.526Z",
    transform: "translate(-7.481 -6.062)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremisesIcon);
export default __webpack_public_path__ + "static/media/premises-icon.ee4ca57f913891a9b753819b56686c05.svg";
export { ForwardRef as ReactComponent };